import React, { ReactNode } from 'react'
import styled from '@emotion/styled'
import { useNavigate } from 'react-router-dom'
import SvgImage from '@components/svg'
import theme from '@utils/theme'
import Row from '@components/row'
import Typography from '@components/typography'

interface BackNavigationProps {
  title?: string
  onClick?: () => void
  rightComponent?: ReactNode
}

const BackNavigation: React.FC<BackNavigationProps> = ({
  title = 'Back',
  onClick,
  rightComponent,
}) => {
  const navigate = useNavigate()

  return (
    <StyledBackNavigation>
      <Row colGap={4} onClick={onClick ? onClick : () => navigate(-1)}>
        <SvgImage src="leftArrow" />
        <Typography content={title} tc="primary" />
      </Row>
      {!!rightComponent && rightComponent}
    </StyledBackNavigation>
  )
}

export default BackNavigation

const StyledBackNavigation = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  cursor: pointer;
  color: ${theme.colors.primary};
  font-size: 16px;
  font-weight: 500;
  justify-content: space-between;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 1024px) {
    border-bottom: 1px solid #00000020;
    width: 100%;
    padding: 12px 0px;
    background: white;
    position: relative;
  }
`
